import * as React from 'react';
import BattlesListPanel from './BattlesListPanel';

export default function UserBattlesTable({ userId }: { userId: number }) {
    return <BattlesListPanel lockedUserId={userId} showTitle={false} compact />;
}
